<template>
  <ButtonAddToCart
    v-if="isPurchasable"
    ref="addToCartButton"
    :prevent-animation="!isOptionSelected || !isQuantitySelected"
    :disabled="isProduct && !productInStock"
    @click="onAddToCartClick"
  />
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue';

import { useCartStore } from '@/shared/pinia/modules/cart';
import { useProductStore } from '@/shared/pinia/modules/product';
import { useProductOptionsStore } from '@/shared/pinia/modules/product-options';
import { useProductQuantitiesStore } from '@/shared/pinia/modules/product-quantities';
import { getErrorMessage } from '@/shared/utils/error';

import ButtonAddToCart from './ButtonAddToCart.vue';

const cartStore = useCartStore();
const productStore = useProductStore();
const quantityStore = useProductQuantitiesStore();
const optionsStore = useProductOptionsStore();

const addToCartButtonRef = useTemplateRef('addToCartButton');
const selectedQuantity = computed(() => quantityStore.quantity);
const isOptionSelected = computed(() => optionsStore.isOptionSelected);
const isQuantitySelected = computed(() => selectedQuantity.value > 0);
const isPurchasable = computed(() => productStore.purchasable);

const isProduct = computed(() => productStore.isProduct);
const productInStock = computed(() => optionsStore.productInStock);

const onAddToCartClick = async () => {
  if (!isOptionSelected.value) {
    optionsStore.showOptionsModal = true;
  } else if (!isQuantitySelected.value) {
    quantityStore.showQuantityModal = true;
  } else {
    try {
      await cartStore.addMainProductToCart();
    } catch (err) {
      const errorMessage = getErrorMessage(err);

      if (errorMessage) {
        addToCartButtonRef?.value?.displayError(errorMessage);
      }
    }
  }
};
</script>
